module.exports = __webpack_public_path__ + "img/home_brown.80fa99ec.svg";